module.exports = __webpack_public_path__ + "409693fc8d390d9c5ab2fa77fa1061e1.pdf";